
// import { CameraResetButton, CustomisationResetButton } from './index'
import { state } from '../../context/store'
import { Icon, Dock, Container, Text } from '../Blocks/index'
import Exit from '../../assets/svgs/exit.svg?react'
import Reset from '../../assets/svgs/reset.svg?react'
import Help from '../../assets/svgs/help.svg?react'
import Cart from '../../assets/svgs/cart.svg?react'
import Camera from '../../assets/svgs/cam-reset.svg?react'
import { closePopups, getKatanaSkew } from '../../utilities'

const ButtonTray = () => {
    return (
        <Dock top="1rem" right="30px">
            <Container >
                <Icon id="help-button" handleClick={(e) => { closePopups(e); state.current.modal.open = true; state.current.modal.instructions = true }}><Help /></Icon>
                <Icon id="camera-button" handleClick={(e) => { closePopups(e); state.current.modal.open = true; state.current.modal.cameraControls = true }}><Camera /></Icon>
                <Icon id="reset-button" handleClick={(e) => { closePopups(e); state.current.modal.open = true; state.current.modal.resetCustomisation = true; state.current.status.confirmResetDesign = false; state.current.status.confirmResetModel = false }}><Reset /></Icon>
                <Icon id="exit-button" handleClick={(e) => { closePopups(e); state.current.modal.open = true; state.current.modal.exitApp = true }}><Exit /></Icon>
                <Icon id="cart-button" handleClick={state.current.initialChoices.inhouseCode ? (e) => { closePopups(e); state.current.modal.open = true; state.current.modal.orderSummary = true } : (e) => { closePopups(e); state.current.modal.open = true; state.current.modal.emptyCart = true }}><Cart /></Icon>
            </Container>
            {/* <Text>{getKatanaSkew()}</Text> */}
        </Dock>
    )
}

export default ButtonTray

